// Institution Onboarding Form Field Constants

export const ESTABLISHED_YEARS = Array.from(
  { length: 2026 - 1900 + 1 },
  (_, i) => (1900 + i).toString()
);

export const INSTITUTION_TYPES = [
  { value: "school", label: "School" },
  { value: "School with Hostel", label: "School with Hostel" },
  // { value: "boarding", label: "Boarding" },
  // { value: "university", label: "University" },
  // { value: "polytechnic", label: "Polytechnic" },
  // { value: "iti", label: "ITI" },
  // { value: "coaching", label: "Coaching Center" },
  // { value: "gurukul", label: "Gurukul" },
  // { value: "pathshala", label: "Pathshala" },
] as const;

export const INSTITUTION_LEVELS = [
  { value: "primary", label: "Primary (1-5)" },
  { value: "middle", label: "Middle (6-8)" },
  { value: "secondary", label: "Secondary (9-10)" },
  { value: "higher_secondary", label: "Higher Secondary (11-12)" },
  { value: "undergraduate", label: "Undergraduate" },
  { value: "postgraduate", label: "Postgraduate" },
  // { value: "doctorate", label: "Doctorate" },
] as const;

export const BOARDS = [
  { value: "cbse", label: "CBSE" },
  { value: "icse", label: "ICSE" },
  { value: "state", label: "State Board" },
  { value: "ib", label: "IB" },
  { value: "cambridge", label: "Cambridge" },
  { value: "nios", label: "NIOS" },
  { value: "other", label: "Other" },
] as const;

export const MEDIUM_OF_INSTRUCTION = [
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" },
  { value: "gujarati", label: "Gujarati" },
  // { value: "marathi", label: "Marathi" },
  // { value: "tamil", label: "Tamil" },
  // { value: "telugu", label: "Telugu" },
  // { value: "kannada", label: "Kannada" },
  // { value: "malayalam", label: "Malayalam" },
  // { value: "bengali", label: "Bengali" },
  // { value: "punjabi", label: "Punjabi" },
  // { value: "sanskrit", label: "Sanskrit" },
  // { value: "urdu", label: "Urdu" },
  // { value: "other", label: "Other" },
] as const;

export const DEPARTMENTS = [
  "Science",
  "Arts",
  "Commerce",
  "Engineering",
  "Medical",
  "Law",
  "Management",
  "Humanities",
  "Education",
  "Agriculture",
  "Computer Science",
  "Information Technology",
  "Pharmacy",
  "Architecture",
  "Design",
  "Fine Arts",
  "Music",
  "Physical Education",
  "Journalism",
  "Social Work",
] as const;

export const FACILITIES = [
  "Library",
  "Computer Lab",
  "Science Lab",
  "Smart Classroom",
  "Auditorium",
  "Playground",
  "Sports Complex",
  "Gymnasium",
  "Cafeteria",
  "Medical Room",
  "WiFi",
  "CCTV",
  "Transportation",
  "Hostel",
  "AC Classrooms",
  "Prayer Hall",
  "Art Room",
  "Music Room",
  "Language Lab",
  "Robotics Lab",
] as const;

export const AFFILIATION_STATUS = [
  { value: "affiliated", label: "Affiliated" },
  { value: "autonomous", label: "Autonomous" },
  { value: "deemed", label: "Deemed" },
  { value: "private", label: "Private" },
  { value: "government", label: "Government" },
  { value: "aided", label: "Government Aided" },
] as const;

export const ACCREDITATION = [
  { value: "naac_a++", label: "NAAC A++" },
  { value: "naac_a+", label: "NAAC A+" },
  { value: "naac_a", label: "NAAC A" },
  { value: "naac_b++", label: "NAAC B++" },
  { value: "naac_b+", label: "NAAC B+" },
  { value: "naac_b", label: "NAAC B" },
  { value: "nba", label: "NBA" },
  { value: "none", label: "Not Accredited" },
  { value: "applied", label: "Applied for Accreditation" },
] as const;

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
] as const;

export const INSTITUTION_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

export const BOARDING_GENDER = [
  { value: "boys", label: "Boys" },
  { value: "girls", label: "Girls" },
] as const;

export const TRUSTEE_DESIGNATIONS = [
  { value: "chairman", label: "Chairman" },
  { value: "vice_chairman", label: "Vice Chairman" },
  { value: "secretary", label: "Secretary" },
  { value: "treasurer", label: "Treasurer" },
  { value: "principal", label: "Principal" },
  { value: "director", label: "Director" },
  { value: "dean", label: "Dean" },
  { value: "manager", label: "Manager" },
  { value: "trustee", label: "Trustee" },
  { value: "other", label: "Other" },
] as const;

// Form step configuration — shared by onboarding, My Institution, and super-admin Review
export const INSTITUTION_ONBOARDING_STEPS = [
  {
    step: 1,
    title: "Basic Information",
    description: "Institution name, type, and contact details",
  },
  {
    step: 2,
    title: "Address Information",
    description: "Complete address and location",
  },
  {
    step: 3,
    title: "School Details (Only if its applicable)",
    description: "Board, medium, and affiliation",
  },
  {
    step: 4,
    title: "Capacity & Facilities",
    description: "Students, staff, and available facilities",
  },
  {
    step: 5,
    title: "Trustee Information",
    description: "Trustee and management details",
  },
] as const;

/** Step titles only — for super-admin Review Institution (same 5 + Review & Action) */
export const INSTITUTION_STEP_TITLES = [
  ...INSTITUTION_ONBOARDING_STEPS.map(s => s.title),
  "Review & Action",
] as const;

// Type exports for TypeScript
export type InstitutionType = (typeof INSTITUTION_TYPES)[number]["value"];
export type InstitutionLevel = (typeof INSTITUTION_LEVELS)[number]["value"];
export type Board = (typeof BOARDS)[number]["value"];
export type MediumOfInstruction =
  (typeof MEDIUM_OF_INSTRUCTION)[number]["value"];
export type Department = (typeof DEPARTMENTS)[number];
export type Facility = (typeof FACILITIES)[number];
export type AffiliationStatus = (typeof AFFILIATION_STATUS)[number]["value"];
export type Accreditation = (typeof ACCREDITATION)[number]["value"];
export type IndianState = (typeof INDIAN_STATES)[number];
export type InstitutionStatus =
  (typeof INSTITUTION_STATUS)[keyof typeof INSTITUTION_STATUS];
export type TrusteeDesignation = (typeof TRUSTEE_DESIGNATIONS)[number]["value"];
